import { Accordion as ReachAccordion } from '@reach/accordion';
import '@reach/accordion/styles.css';
import { FC } from 'react';

export interface AccordionProps {}

export const Accordion: FC<AccordionProps> = ({ children }) => {
  return <ReachAccordion>{children}</ReachAccordion>;
};
